import api from '@/api/api.js'

// Dépenses par la caisse (modèle de la Remise) : consultation et validation après coup.
// Droits décidés par be_caisse : l'administrateur valide, trésorerie et comptable consultent.
const base = '/caisse-operations/depenses-caisse'

export default {
    list(params = {}) {
        return api.comptabilite().get(base, { params }).then(response => response.data)
    },
    countToValidate() {
        return api.comptabilite().get(base + '/a-valider/nombre').then(response => response.data)
    },
    validate(id, commentaire = '') {
        return api.comptabilite().post(base + '/' + Number(id) + '/valider', { commentaire }).then(response => response.data)
    },
}
